var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Expose } from 'class-transformer';
export default class LocationModel {
}
__decorate([
    Expose({ name: 'lat' })
], LocationModel.prototype, "lat", void 0);
__decorate([
    Expose({ name: 'long' })
], LocationModel.prototype, "long", void 0);
__decorate([
    Expose({ name: 'name' })
], LocationModel.prototype, "name", void 0);
__decorate([
    Expose({ name: 'timezone' })
], LocationModel.prototype, "timezone", void 0);
